exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-2b8e2841]{text-align:center}.colour-pdf[data-v-2b8e2841]{color:red}.colour-excel[data-v-2b8e2841]{color:green}.btn-export[data-v-2b8e2841]{text-align:right;margin-bottom:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b8e2841","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/files/BoxesByMonth.vue
// module id = 235
// module chunks = 58